import { engageAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { xeroAPIUrls } from '../data';

export type GetXeroInvoiceDisconnect = {
  response: boolean;
};

export const getXeroInvoiceDisconnect = withLogger(
  async (): Promise<boolean> => {
    await engageAxiosClient.get(xeroAPIUrls.xeroDisconnect);

    return true;
  },
);
